var cultureKey = 'language'

export function normalizeCulture(culture: string) {
  return culture.startsWith('fr') ? 'fr-CA' : 'en-CA'
}

export function getStoredCulture() {
  var stored = localStorage.getItem(cultureKey)
  if (stored?.startsWith('fr')) {
    return 'fr-CA'
  }
  if (stored?.startsWith('en')) {
    return 'en-CA'
  }
  return 'en-CA'
}

export function setStoredCulture(culture: string) {
  localStorage.setItem(cultureKey, normalizeCulture(culture))
}

export function setCultureCookie(culture: string) {
  var normalized = normalizeCulture(culture)
  var cultureEscaped = encodeURIComponent(normalized)
  var cvalue = `c=${cultureEscaped}|uic=${cultureEscaped}`
  document.cookie = `.AspNetCore.Culture=${cvalue};path=/;max-age=${60 * 60 * 24 * 90}`
}

export function applyCultureLocally(culture: string) {
  var normalized = normalizeCulture(culture)
  setStoredCulture(normalized)
  setCultureCookie(normalized)
  return normalized
}

export function switchCulture(culture: string) {
  applyCultureLocally(culture)
  window.location.reload()
}

export function getTwoLetterCulture(culture: string) {
  return culture.startsWith('fr') ? 'fr' : 'en'
}

export function getAuthUiLocales(culture: string) {
  return getTwoLetterCulture(culture) === 'en' ? 'en' : 'fr-CA'
}
